import getFetchOptions from 'utils/getFetchOptions';

import { PaginatedResponse, handlePaginatedResponse, handleResponse, toQueryString } from '../utils';
import {
  AdministerLoanStatementRequest,
  LoanStatementSummary,
  LoanStatementSummaryQueryParams,
  TriggerLoanStatementCreationRequest,
} from './loanstatement.types';

export const administerLoanStatement = async (
  apiAprilBaseUri: string,
  loanStatementId: string,
  payload: AdministerLoanStatementRequest,
): Promise<object> => {
  const options = await getFetchOptions('PATCH', JSON.stringify(payload));
  return await fetch(`${apiAprilBaseUri}/loans/enterprise/statements/${loanStatementId}`, options).then(handleResponse);
};

export const triggerLoanStatementCreation = async (
  apiAprilBaseUri: string,
  loanId: string,
  payload: TriggerLoanStatementCreationRequest,
): Promise<object> => {
  const options = await getFetchOptions('PATCH', JSON.stringify(payload));
  return await fetch(`${apiAprilBaseUri}/loans/enterprise/${loanId}`, options).then(handleResponse);
};

export const getLoanStatementSummaries = async (
  apiAprilBaseUri: string,
  queryParams: LoanStatementSummaryQueryParams,
): Promise<PaginatedResponse<Array<LoanStatementSummary>>> => {
  let qParams = toQueryString(queryParams);
  const options = await getFetchOptions('GET');

  return await fetch(`${apiAprilBaseUri}/loans/statements${qParams}`, options).then(handlePaginatedResponse);
};
